/** User-facing message from external folder link API failures (e.g. 412 repository kit). */
export function getExternalFolderLinkErrorMessage(
  error: unknown,
  fallback: string,
): string {
  if (error && typeof error === "object") {
    const withUserResponse = error as {
      userResponse?: { message?: string } | null;
      response?: { message?: string };
    };
    if (withUserResponse.userResponse?.message) {
      return withUserResponse.userResponse.message;
    }
    if (withUserResponse.response?.message) {
      return withUserResponse.response.message;
    }
  }
  if (error instanceof Error && error.message) {
    return error.message;
  }
  return fallback;
}
